import {
  CreateGeneralCargoAreaDto,
  GeneralCargoAreaDto,
  GeneralCargoAreasApi,
} from '@storage/app/api'
import { AxiosPromise } from 'axios'

export class GeneralCargoAreaService {
  constructor(private api: GeneralCargoAreasApi) {}

  async getAll(): Promise<Array<GeneralCargoAreaDto>> {
    const { data: GeneralCargoAreas } = await this.api.generalCargoAreasGetAll()
    return GeneralCargoAreas
  }

  async create(createGeneralCargoAreaDto: CreateGeneralCargoAreaDto): Promise<GeneralCargoAreaDto> {
    const { data: generalCargoArea } = await this.api.generalCargoAreasCreate({
      createGeneralCargoAreaDto,
    })
    return generalCargoArea
  }

  async update(generalCargoAreaDto: GeneralCargoAreaDto) {
    await this.api.generalCargoAreasUpdate({
      id: generalCargoAreaDto.id,
      updateGeneralCargoAreaDto: generalCargoAreaDto,
    })
  }

  async isNameUnique(name: string, id?: string): AxiosPromise<boolean> {
    return await this.api.generalCargoAreasIsNameUnique({
      name,
      id,
    })
  }

  async delete(generalCargoAreaId: string) {
    await this.api.generalCargoAreasDelete({ id: generalCargoAreaId })
  }
}
